import Step from '../steps/step.vue';

export default Step;


// WEBPACK FOOTER //
// ./src/components/step/index.js